import Phaser from 'phaser';

/**
 * DemoGame - A minimal Phaser scene that demonstrates the game runtime.
 * This is a clicker game: click the button to increase score.
 *
 * M0: Serves as a template reference and integration test for Phaser.
 */
export default class DemoGame extends Phaser.Scene {
  private score = 0;
  private scoreText!: Phaser.GameObjects.Text;
  private button!: Phaser.GameObjects.Container;
  private buttonBg!: Phaser.GameObjects.Rectangle;
  private buttonText!: Phaser.GameObjects.Text;

  constructor() {
    super({ key: 'DemoGame' });
  }

  create(): void {
    const { width, height } = this.scale;

    // Title
    this.add
      .text(width / 2, height * 0.15, 'Demo Clicker', {
        fontSize: '32px',
        color: '#e94560',
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    // Score display
    this.scoreText = this.add
      .text(width / 2, height * 0.3, 'Score: 0', {
        fontSize: '28px',
        color: '#eaeaea',
      })
      .setOrigin(0.5);

    // Click button
    this.button = this.add.container(width / 2, height * 0.55);

    this.buttonBg = this.add.rectangle(0, 0, 200, 80, 0xe94560);
    this.buttonBg.setStrokeStyle(3, 0xffffff);

    this.buttonText = this.add.text(0, 0, 'CLICK ME!', {
      fontSize: '24px',
      color: '#ffffff',
      fontStyle: 'bold',
    });
    this.buttonText.setOrigin(0.5);

    this.button.add([this.buttonBg, this.buttonText]);
    this.button.setSize(200, 80);
    this.button.setInteractive({ useHandCursor: true });

    this.button.on('pointerdown', () => this.onClick());
    this.button.on('pointerover', () => {
      this.buttonBg.setFillStyle(0xff6b81);
    });
    this.button.on('pointerout', () => {
      this.buttonBg.setFillStyle(0xe94560);
    });

    // Instructions
    this.add
      .text(width / 2, height * 0.8, 'Click the button to score points!', {
        fontSize: '16px',
        color: '#a0a0a0',
      })
      .setOrigin(0.5);
  }

  private onClick(): void {
    this.score += 1;
    this.scoreText.setText(`Score: ${this.score}`);

    // Button press animation
    this.button.setScale(0.95);
    this.time.delayedCall(50, () => {
      this.button.setScale(1);
    });

    // Score popup
    const popup = this.add
      .text(this.button.x + Phaser.Math.Between(-50, 50), this.button.y - 40, '+1', {
        fontSize: '20px',
        color: '#e94560',
        fontStyle: 'bold',
      })
      .setOrigin(0.5);

    this.tweens.add({
      targets: popup,
      y: popup.y - 50,
      alpha: 0,
      duration: 600,
      onComplete: () => popup.destroy(),
    });
  }
}
